// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1kLpl","avatar":"style_avatar__10_CW","menuIcon":"style_menuIcon__1h65C"};